import script from "./record.vue?vue&type=script&setup=true&lang=js"
export * from "./record.vue?vue&type=script&setup=true&lang=js"

import "./record.vue?vue&type=style&index=0&id=8a2db106&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2db106"]])

export default __exports__